export default [
    "24 24",
    '<path id="Vector" d="M8 12H16M15 8H17C19.2091 8 21 9.79086 21 12C21 14.2091 19.2091 16 17 16H15M9 8H7C4.79086 8 3 9.79086 3 12C3 14.2091 4.79086 16 7 16H9" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

